import { render } from "./About.vue?vue&type=template&id=4b08facb&scoped=true"
import script from "./About.vue?vue&type=script&lang=ts"
export * from "./About.vue?vue&type=script&lang=ts"
script.render = render
script.__scopeId = "data-v-4b08facb"

export default script